'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { of } from 'rxjs/observable/of';
import { startWith } from 'rxjs/operators/startWith';
import ContentRoutes from 'ContentUtils/Routes';
import { PUBLISHED_CONTENT } from '../actions/ActionTypes';
import { receiveContent, requestContent, requestedContentFailed, requestedPublishContentFailure, requestedPublishContentSuccess, requestPublishContent } from '../actions/ContentActions';
import { closeModal } from '../actions/ModalActions';
import { ContentTypeToContentId } from '../constants/base';
import { completeOnboardingPublishTask } from '../utils/cmsOnboarding';
export default ((action$, _, {
  ContentClient
}) => action$.ofType(PUBLISHED_CONTENT).pipe(mergeMap(({
  payload: {
    contentPageId,
    contentType
  }
}) => ContentClient.publishContent(contentType, contentPageId).pipe(mergeMap(() => ContentClient.fetchContent({
  contentPageId,
  contentType
}).pipe(mergeMap(content => {
  completeOnboardingPublishTask(contentType);
  return of(receiveContent(content), closeModal(), requestedPublishContentSuccess(contentType));
}), catchError(error => of(requestedContentFailed(error))), startWith(requestContent()))), catchError(error => {
  const additionalTranslationsOptions = {
    editUrl: ContentRoutes.edit(contentPageId, ContentTypeToContentId[contentType])
  };
  return of(requestedPublishContentFailure(error, contentType, additionalTranslationsOptions));
}), startWith(requestPublishContent())))));